import styled from 'styled-components';
import { GlobalStyled } from '../shared/GlobalStyled';
import { SaveToAccountButtonTemplate } from './SaveToAccountButtonTemplate';

export const SaveToAccountButton = styled(SaveToAccountButtonTemplate)`
    ${GlobalStyled}
`;
